import {
  IApiGeoGeocodeCachedRequest,
  IApiGeoGeocodeCachedResponse,
  IApiGeoGeocodeCachedResponse200,
  createApiGeoGeocodeCachedModel,
  fetchApiGeoGeocodeCached,
} from 'shared/repositories/monolith-cian-realty/api/geo/geocode-cached';
import { FetchAssertsService } from 'shared/services/FetchAssertsService';
import { IApplicationContext } from 'shared/types/applicationContext';

export async function fetchGeocodeCachedService(
  dependencies: IApplicationContext,
  parameters: IApiGeoGeocodeCachedRequest,
): Promise<IApiGeoGeocodeCachedResponse> {
  const {
    httpApi,
    custom: { subdomain },
    logger,
  } = dependencies;

  const fetchAssertsService = new FetchAssertsService(
    createApiGeoGeocodeCachedModel(parameters),
    'src/shared/store/serverSide/monolith-cian-realty/api/geo/geocode-cached/internal/fetchService.ts',
    logger,
  );

  return fetchApiGeoGeocodeCached<IApiGeoGeocodeCachedResponse200>({
    config: { subdomain },
    httpApi,
    parameters,
  }).then(
    result => {
      const statusCode = result.statusCode;

      switch (result.statusCode) {
        case 200:
          return result.response;
        default:
          throw fetchAssertsService.assertUnknownStatusCodeError(statusCode);
      }
    },
    error => {
      throw fetchAssertsService.assertUnknownServerError(error);
    },
  );
}
